export default __webpack_public_path__ + "static/media/upgradeArrow.7e3a0555.svg";